import {
  FormControl,
  Typography,
  Autocomplete,
  TextField,
} from "@mui/material";
import { IGenericAutocomplete } from "../interfaces/form";
import { useAutoComplete } from "../customHooks/useAutoComplete";
import { useEffect } from "react";

export const GenericAutocomplete = ({
  initialValues,
  options,
  allOption,
  handleChangeValue,
  label,
  fieldKey,
  noOptionsText,
}: IGenericAutocomplete) => {
  const { selectedOptions, setSelectedOptions, handleSelectOption } =
    useAutoComplete({
      allOption,
      handleChangeValue,
      fieldKey,
    });

  const parseInitialValuesToSelectedOptions = () =>
    initialValues[fieldKey].includes(allOption.id)
      ? [allOption]
      : options.filter(
        ({ id: optionId }) =>
          initialValues[fieldKey].includes(optionId) ||
        initialValues[fieldKey].includes(String(optionId))
      );

  useEffect(
    () => setSelectedOptions(parseInitialValuesToSelectedOptions()),
    []
  );

  return (
    <FormControl fullWidth size="small">
      <Typography className="f-s-14 m-b-10">{label}</Typography>
      <Autocomplete
        multiple
        size="small"
        getOptionLabel={(option) => option.name}
        value={selectedOptions}
        options={[allOption, ...options]}
        onChange={(_event, _value, _action, details: any) =>
          handleSelectOption(details?.option)
        }
        sx={{ fontSize: 14 }}
        renderInput={(params) => (
          <TextField {...params} fullWidth size="small" />
        )}
        noOptionsText={noOptionsText}
        disableClearable
        isOptionEqualToValue={(option, value) => option.id === value.id}
        filterSelectedOptions
      />
    </FormControl>
  );
};
